import React, { useState, useRef, useEffect, useCallback } from "react";
import TopicData from "./chapterData/ChapterData";
import "./Chapter.css";
import anime from "animejs/lib/anime.es.js";

function Chapter({ chapter }) {
  const topics = chapter[0].topics;
  console.log(topics);
  const [topicData, setTopicData] = useState(topics[0]);
  //animation
  const animationRef = useRef();
  useEffect(() => {
    animationRef.current = anime({
      targets: ".anim",
      opacity: [0, 1],
      delay: 0,
      loop: false,
      direction: "alternate",
      easing: "easeInOutSine",
    });
  }, []);

  return (
    <div className="chapter-data row">
      <div className="topic-list col-md-5 col-xs-12">
        {topics.map((topic) => {
          return (
            <div
              className="topic-list-item"
              onClick={(e) => {
                var node = document.getElementsByClassName("topic-list-item");
                node = [].slice.call(node);
                node.map((element) => {
                  return (element.style.backgroundColor = "white");
                });
                console.log(e);
                e.target.style.backgroundColor = "rgba(107, 81, 202, 0.301)";

                setTopicData(topics[topic.id - 1]);
                animationRef.current.restart();
                return;
              }}
              key={topic.id}
            >
              {topic.topicName}
            </div>
          );
        })}
      </div>
      <div className="topic-list col-md-5 col-xs-12 anim">
        <TopicData topicData={topicData} />
      </div>
    </div>
  );
}

export default Chapter;
